export enum E_REASON_OPTIONS {
  VIOLENT_OR_REPULSIVE_CONTENT = 'violent_or_repulsive_content',
  HATEFUL_OR_ABUSIVE_CONTENT = 'hateful_or_abusive_content',
  SPAM_OR_MISLEADING = 'spam_or_misleading',
  LEGAL_ISSUE = 'legal_issue',
  OTHER = 'other',
}
